/**
 * @title   autocompletePlaces
 * @author  Holger Schauf
 * @type    loader
 * @desc    load places
 * @date    12.2014
 */
var places = {

    active: false,
    isLoaded: false,
    isLoading: false,

    cfg: {
        region: 'de'
    },

    /**
     * @returns {boolean}
     */
    loadApi: function () {

        if (ApplicationProperties.get('unknownCitiesActive')) {
            this.active = ApplicationProperties.get('unknownCitiesActive');
        }

        if (!this.active || this.isLoaded || this.isLoading) {
            return false;
        }

        if (ApplicationProperties.get('localization')) {
            this.cfg.region = ApplicationProperties.get('localization');
        }

        this.isLoading = true;

        /* eslint-disable-next-line jquery/no-ajax */
        $.getScript(
            '//maps.google.com/maps/api/js?client=gme-silvertoursgmbh&libraries=places&language=' + this.cfg.region + '&callback=placesApiLoaded'
        );

        return false;

    }

};

var placesApiLoaded = function () {
    places.isLoaded = true;
    places.isLoading = false;
};

function activateSuggestGoogleAddressAbTest()
{
    places.active = true;

    // set placeholder
    var input = $('form#suche #dep');
    input.attr('placeholder', 'Ville, aéroport ou adresse');

    // set label text
    $('label[for="'+ input.attr('id') +'"]').text('Lieu');
}
